export default "__VITE_ASSET__1BpkfoOU__"